import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useStaticQuery, graphql } from "gatsby"
import styles from "./produit.module.scss"
import Img from "gatsby-image"

function services() {
  const { site, map, news, promo, envelope } = useStaticQuery(
    graphql`
      query {
        site: site {
          siteMetadata {
            websiteConfig {
              services {
                icon
                title
                content
                link
              }
            }
          }
        }
        map: file(relativePath: { eq: "map.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        news: file(relativePath: { eq: "services/services.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        promo: file(relativePath: { eq: "services/promo.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        envelope: file(relativePath: { eq: "services/envelope.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <div className={`row ${styles.back} `} id="produit">
      <div className="col-lg-12">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              <h2>Notre reseau de supports mobiles</h2>
              <div className="sBar" />
              <span className="welcome" style={{ color: "#fff" }}>
                Publicités & Marketing
              </span>
            </div>
          </div>
          <div className={`row ${styles.service}`}>
            <div className="col-lg-6 d-flex align-items-center">
              <Img className={` w-100`} fluid={map.childImageSharp.fluid} />
            </div>
            <div className="col-lg-6 d-flex align-items-center flex-wrap justify-content-center">
              <div id="geo">
                <h3 style={{ color: "#fff" }}>
                  POP UP Puplicitaire Géolocalisé & Géociblé
                </h3>
                <p>
                  Une excellente occasion d’explorer et d’interagir avec votre
                  marque, sans concurrence des autres médias. Informez et
                  divertissez votre audience tout en obtenant des données
                  précieuses sur vos clients afin de réussir vos campagnes.
                </p>
              </div>
            </div>
          </div>
          <div className={`row ${styles.service}`}>
            <div className="col-lg-6 d-flex align-items-center flex-wrap justify-content-center">
              <div id="news">
                <h3 style={{ color: "#fff" }}>
                  POP UP Puplicitaire Géolocalisé & Géociblé
                </h3>
                <p>
                  Une excellente occasion d’explorer et d’interagir avec votre
                  marque, sans concurrence des autres médias. Informez et
                  divertissez votre audience tout en obtenant des données
                  précieuses sur vos clients afin de réussir vos campagnes.
                </p>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <Img className={` w-100`} fluid={news.childImageSharp.fluid} />
              <Img
                className={styles.envelope}
                fluid={envelope.childImageSharp.fluid}
              />
            </div>
          </div>
          <div className={`row ${styles.service}`}>
            <div className="col-lg-6 d-flex align-items-center">
              <Img
                className={` w-100`}
                imgStyle={{
                  top: "47px",
                  right: 0,
                  width: "318px",
                  height: "355px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                fluid={promo.childImageSharp.fluid}
              />
            </div>
            <div className="col-lg-6 d-flex align-items-center flex-wrap justify-content-center">
              <div id="ads">
                <h3 style={{ color: "#fff" }}>
                  POP UP Puplicitaire Géolocalisé & Géociblé
                </h3>
                <p>
                  Une excellente occasion d’explorer et d’interagir avec votre
                  marque, sans concurrence des autres médias. Informez et
                  divertissez votre audience tout en obtenant des données
                  précieuses sur vos clients afin de réussir vos campagnes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default services
